<template>
  <div id="info">
  <transition appear name="info">
<div class="container">
<div class="columns">
    <div class="has-text-left column is-three-fifths">
      <h1 class="subtitle"><span class="underline">予測精度アップデート版開発にあたって</span></h1>
      <p class="mb-10">
      いつもご利用いただきありがとうございます。<br>
      最近はそこそこ多くの人にこのサイトを見てもらえるようになりました。
      </p>
      <p class="mb-10">
      そこで、<b>2023年11月あたりの公開を目処に、夕焼け予報をアップデート</b>しようと思っています。
      </p>
      <p class="mb-10">
      このサイトは正直やっつけで作った予報で、ある程度は予測できますがあまり精度がよくありません。
      1日に数人しかアクセスがない頃はそれでいいと思っていましたが、それなりの人にアクセスしていただいている現在、
      もう少し予報の精度を高めたいと思っています。
      </p>
      <p class="mb-10">
      ただの趣味なので、あまりお金をかけすぎずにできる範囲でできる限りのことをやる予定です。
      あと自分は社会人なのでどれだけ開発に時間が取れるか謎です...
      </p>
      <p class="mb-40">
      というわけで、<b>すごーく空が焼けている日をけっこう的中させる、くらいの精度を目指そう</b>と思っています。
      開発までしばしお待ちください。
      </p>

      <h2 class="subsubtitle"><span class="underline">追記: 2023/6/10</span></h2>
      <p class="mb-20">
      5月にこっそり予測モデルを更新しましたが、6月9日の東京の夕焼けを外してました。<br>
      まだまだ改善の余地がありそうです...
      </p>

      <h2 class="subsubtitle"><span class="underline">追記: 2023/11/6</span></h2>
      <p class="mb-40">
      というわけであまり開発に時間が取れなかったのですが、予測モデルの更新と微調整を行いました。<br>
      そこまで精度が上がった印象がないですね...<br>
      ただやるべきタスクはたくさん出てきたので、折を見て更新していこうと思います。<br>
      </p>

      <router-link to="/" class="mt-40">
          <span class="blue">トップへ戻る</span>
      </router-link>
    </div>
</div>
</div>
  </transition>
  <transition appear>
   <div class="background" v-if="!phone" :style="{ 'background-image': `url(${backgroundImage})` }"></div>
  </transition>
  </div>
  
</template>


<script>
import BackgroundImage from "@/assets/images/background.png";
import Mobile from 'ismobilejs'

export default {
  name: 'Info',
  data () {
    return {
      backgroundImage: BackgroundImage,
      phone: false
    }
  },
  created() {
  }, 
  mounted(){
    if (Mobile.phone){
      this.phone = true
    }
  },
  methods:{
  },
  watch: {
    '$route' (to, from) {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.about-enter-active{
  transition: all .7s .2s;
}
.about-leave-active{
  transition: all .7s .0s;
}
.about-enter, .about-leave-to{
  opacity: 0;
}
span.underline{
  border-bottom: solid 2px rgb(180,250,215);
  padding-bottom: 0px;
}
span.blue{
  color: rgb(80,160,235)
}


div.background{
  content:"";
  display:block;
  position: fixed;
  z-index:-2;
  top:0;
  left:50vw;
  width: 40vw;
  height:100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  opacity:0.15;
}
</style>



// WEBPACK FOOTER //
// src/components/Info.vue